export default __webpack_public_path__ + "static/media/webbanner_flavorzone.85eb62e7.jpg";